var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDoubleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none",
    rx: 0,
    ry: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.325 18.4213C18.215 18.5413 18.055 18.6013 17.905 18.6013C17.755 18.6013 17.595 18.5413 17.475 18.4213L11.475 12.4213C11.245 12.1813 11.245 11.8013 11.475 11.5713L17.475 5.5713C17.715 5.3413 18.095 5.3413 18.325 5.5713C18.555 5.8113 18.555 6.1913 18.325 6.4213L12.755 12.0013L18.325 17.5713C18.555 17.8113 18.555 18.1913 18.325 18.4213ZM12.525 18.4213C12.415 18.5413 12.255 18.6013 12.105 18.6013C11.955 18.6013 11.795 18.5413 11.675 18.4213L5.67498 12.4213C5.44498 12.1813 5.44498 11.8013 5.67498 11.5713L11.675 5.5713C11.915 5.3413 12.295 5.3413 12.525 5.5713C12.755 5.8113 12.755 6.1913 12.525 6.4213L6.94498 11.9913L12.525 17.5713C12.755 17.8113 12.755 18.1913 12.525 18.4213Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleLeft);
export default __webpack_public_path__ + "static/media/chevron-double-left.f4455163155522a23273592988884c5e.svg";
export { ForwardRef as ReactComponent };